var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIotIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.876,
    height: 27.842,
    viewBox: "0 0 35.876 27.842",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    transform: "translate(0.721 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_5",
    "data-name": "Subtraction 5",
    d: "M22.436,19.37h0c-.129-.126-.275-.258-.434-.393.271-.964.6-2.121,1.012-3.539a10.607,10.607,0,0,1,1.866,1.51L22.437,19.37Zm-10.237,0h0L9.771,16.934a10.454,10.454,0,0,1,7.541-3.142,10.758,10.758,0,0,1,2.53.3c-.656,1.225-1.239,2.3-1.731,3.2a7.631,7.631,0,0,0-.79-.041A7.186,7.186,0,0,0,12.2,19.37ZM7.3,14.509h0L4.868,12.09a16.85,16.85,0,0,1,5.751-3.879,17.734,17.734,0,0,1,12.513-.333c-.619,1.18-1.154,2.2-1.626,3.088a14.21,14.21,0,0,0-4.188-.613A13.982,13.982,0,0,0,7.3,14.509Zm20.036,0h0a15.381,15.381,0,0,0-3.327-2.481l.068-.235c.295-1,.605-2.055.925-3.134a17.276,17.276,0,0,1,4.769,3.432l-2.433,2.419Zm4.9-4.854h0a20.812,20.812,0,0,0-14.915-6.2h-.012A20.753,20.753,0,0,0,2.438,9.613L0,7.179c.109-.1.221-.21.329-.315l.006-.006c.216-.21.461-.448.72-.657l.008-.006.313-.255.015-.011c.708-.578,1.44-1.175,2.2-1.7a23.18,23.18,0,0,1,5.021-2.63A24.382,24.382,0,0,1,17.338,0c.148,0,.31,0,.493,0A24.2,24.2,0,0,1,29.087,3.017a24.543,24.543,0,0,1,4.874,3.526l.258.24c.146.137.29.272.437.408V7.23c-.432.421-.891.869-1.34,1.321-.244.242-.5.5-.7.715l-.123.126-.254.26Z",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9984",
    "data-name": "Path 9984",
    d: "M36.479,227.386a6,6,0,0,1-.6-.15,2.652,2.652,0,0,1-1.822-2.087,2.62,2.62,0,0,1,1.057-2.75c.676-.509,6.193-10.984,8.9-16.17a.305.305,0,0,1,.564.227c-1.683,5.66-5.084,17.2-5.044,18a2.73,2.73,0,0,1-2.221,2.878c-.086.019-.17.038-.256.055Z",
    transform: "translate(-19.429 -200.045)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIotIcon);
export default __webpack_public_path__ + "static/media/iotIcon.043ab54bf72ec3c083746880caa25f01.svg";
export { ForwardRef as ReactComponent };